import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { Autocomplete, Button, TextField } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import React, { useState, useEffect, useRef, useCallback } from "react";
import Select from "react-select";
import AgGridTable from "../../utilities/AgGridTable";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import CustomDatePicker from "../../utilities/CustomDatePicker";

const initialValue = {
  employeeName: null,
  startDate: null,
  endDate: null,
};

const initialRowDat = [
  {
    employee: "ROYSIM",
    OFC: "office",
    BW: "2",
    HO: "3",
    BT: "5",
    personal: "12",
    annualLeave: "25",
    sickLeave: "6",
    unpaidLeave: "8",
    maternity: "5",
    parental: "6",
    publicHoliday: "10",
    variable: "0",
    date: "2023-11-24",
  },
  {
    employee: "Noshan",
    OFC: "work from office",
    BW: "2",
    HO: "3",
    BT: "5",
    personal: "12",
    annualLeave: "25",
    sickLeave: "6",
    unpaidLeave: "8",
    maternity: "5",
    parental: "6",
    publicHoliday: "10",
    variable: "0",
    date: "2023-11-24",
  },
  {
    employee: "Tom",
    OFC: "work from office",
    BW: "2",
    HO: "3",
    BT: "5",
    personal: "12",
    annualLeave: "25",
    sickLeave: "6",
    unpaidLeave: "8",
    maternity: "5",
    parental: "6",
    publicHoliday: "10",
    variable: "0",
    date: "2023-11-24",
  },
];

const EmployeeAttendance = ({ setPage }) => {
  const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;

  const gridRef = useRef();
  const [searchType, setSearchType] = useState("byEmployeeName");
  const [searchBy, setSearchBy] = useState(initialValue);
  const [rowData , setRowData] = useState(initialRowDat);
  const [employee, setEmployee] = useState();
  const [columnDefs, setColumnDefs] = useState([
    { field: "date",  },
    { field: "employee",hide: true },
    { field: "OFC" },
    { field: "BW" },
    { field: "HO" },
    { field: "BT" },
    { field: "personal" },
    { field: "annualLeave" },
    { field: "sickLeave" },
    { field: "unpaidLeave" },
    { field: "maternity" },
    { field: "parental" },
    { field: "publicHoliday" },
    { field: "variable" },
  ]);
  const searchOption = [
      { value: "byEmployeeName", label: "Name" },
    { value: "byDate", label: "Date" },
  ];

  const onGridReady = useCallback((params) => {
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
  }, []);

  const handleSearchTypeChange = (data) => {
    setSearchType(data.value);
    if(data.value === 'byDate'){
        gridRef.current.columnApi.setColumnVisible("employee", true);
        gridRef.current.columnApi.setColumnVisible("date", false);
    }else{
        gridRef.current.columnApi.setColumnVisible("employee", false);
        gridRef.current.columnApi.setColumnVisible("date", true);
    }
  };

  const employeeList = async () => {
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      let employees = list.data?._embedded?.employees;
      setEmployee(employees);
    } catch (error) {
      setError(error.message);
    }
  };
  useEffect(() => {
    employeeList();
  }, []);

  return (
    <>
      <div className="flex">
        <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 space-x-8 m-16">
          <div className="flex items-center">
            <label>Filter By</label>
            <Select
              name="searchType"
              value={
                searchType &&
                searchOption &&
                searchOption.filter((obj) => searchType.includes(obj.value))
              }
              onChange={handleSearchTypeChange}
              className="w-[140px]"
              options={searchOption}
              styles={customStyles()}
            />
          </div>

          {searchType === "byDate" ? (
            <>
              <div className="flex items-center">
                <label>Start Date:</label>
                <div className="grid">
                  <CustomDatePicker
                    className="w-[170px]"
                    format={"dd-MM-yyyy"}
                    name={"startDate"}
                    value={searchBy.startDate}
                    maxDate={new Date()}
                    // handleChange={(e) => handleChange(e, "startDate")}
                  />
                </div>
              </div>
              <div className="flex items-center">
                <label>End Date:</label>
                <div className="grid">
                  <CustomDatePicker
                    className="w-[170px]"
                    format={"dd-MM-yyyy"}
                    name={"endDate"}
                    value={searchBy.endDate}
                    maxDate={new Date()}
                    // handleChange={(e) => handleChange(e, "endDate")}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center">
                <label>Employee Name</label>
                <Autocomplete
                  id="free-solo-demo"
                  className="w-[200px]"
                  placeholder="Employee Name"
                  value={searchBy.employeeName}
                  freeSolo
                  // onChange={(event, value) => setSearchBy({ ...searchBy, employeeName: value })}
                  options={employee?.map((option) => option.displayName)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
            </>
          )}
          <div className="flex items-center">
            <Button
              variant="contained"
              color="warning"
              // onClick={handleSearch}
              // disabled={disabled}
            >
              {/* Search */}
              <FuseSvgIcon>heroicons-outline:search-circle</FuseSvgIcon>
            </Button>
          </div>
        </div>
        <div>
          <Button
            className="mt-24"
            onClick={() => setPage(0)}
            variant="contained"
            color="warning"
          >
            <FuseSvgIcon>heroicons-outline:arrow-circle-left</FuseSvgIcon>
          </Button>
        </div>
      </div>
      <div className="h-full">
        <AgGridTable
          gridRef={gridRef}
          rowData={initialRowDat}
          columnDefs={columnDefs}
          hideCheckbox={true}
          suppressRowCount={true}
          enableRowGroup={true}
        //   defaultColDef={defaultColDef}
          onGridReady={onGridReady}
        />
      </div>
    </>
  );
};

export default EmployeeAttendance;
